module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/esPowerStance-1381274efb7c4ae5e4948aa6c44fad6c.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/esPowerStance.png
// module id = 2441
// module chunks = 2